const getUserCredentials = state => state.user
const getFaq = state => state.faq
const getNotifications = state => state.notification
const getMyCourses = state => state.myCourses
const getCertificates = state => state.certificates
const getCertificateCheckInfo = state => state.certificateCheckInfo
const getCertificated = state => state.certificated
const getCertificatedData = state => state.certificatedData
const getBranches = state => state.branches

export default {
    getUserCredentials,
    getFaq,
    getNotifications,
    getMyCourses,
    getCertificates,
    getCertificateCheckInfo,
    getCertificated,
    getCertificatedData,
    getBranches,
}